"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SEARCH_RESULTS_PAGE = void 0;
const SEARCH_RESULTS_PAGE = exports.SEARCH_RESULTS_PAGE = 'search-results-page';
